var React = require('react');

function HamburgerIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m501.333 96h-490.666c-5.888 0-10.667 4.779-10.667 10.667s4.779 10.667 10.667 10.667h490.667c5.888 0 10.667-4.779 10.667-10.667s-4.78-10.667-10.668-10.667z","key":0}),React.createElement("path",{"d":"m501.333 245.333h-490.666c-5.888 0-10.667 4.779-10.667 10.667s4.779 10.667 10.667 10.667h490.667c5.888 0 10.667-4.779 10.667-10.667s-4.78-10.667-10.668-10.667z","key":1}),React.createElement("path",{"d":"m501.333 394.667h-490.666c-5.888 0-10.667 4.778-10.667 10.666s4.779 10.667 10.667 10.667h490.667c5.888 0 10.667-4.779 10.667-10.667-.001-5.888-4.78-10.666-10.668-10.666z","key":2})]);
}

HamburgerIcon.defaultProps = {"enableBackground":"new 0 0 512 512","viewBox":"0 0 512 512","fill":"currentColor"};

module.exports = HamburgerIcon;

HamburgerIcon.default = HamburgerIcon;
